import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetMic: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 1a3 3 0 00-3 3v7a3 3 0 006 0V4a3 3 0 00-3-3zm-7 10a7 7 0 0014 0M12 18v4m-3 0h6" />
      </svg>
    </div>
  );
};

export default WidgetMic;
